import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import CircleImage from '../../components/CircleImage';

// TYPES
import { SafetyChecklistChecklistRecipientSummary } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RecipientsModalTypes {
	recipients?: SafetyChecklistChecklistRecipientSummary[];
	closeModal?: closeModalType;
}

const RecipientsModal: React.FC<RecipientsModalTypes> = ({ recipients, closeModal }) => (
	<>
		{recipients && recipients.length > 0 ? (
			<section className="info-section incident-form mtop-0 bg-white rounded border-grey-3 p-3 max-height-550 w-100">
				<ul>
					{recipients.map((item, index) => (
						<li key={item.id} className="row-container no-hover">
							<div className={`row detail-row ${index === recipients.length - 1 ? 'border-bottom-0' : ''}`}>
								<div className="col-1 pdl-0">
									<CircleImage firstName={item.name} lastName={item.name} />
								</div>
								<div className="col-11">
									<div className="row detail-info center">
										<div className="col-12 detail-name">
											<p className="detail-name mbtom-0">{item.name}</p>

											<p className="label body-medium fw-bold text-grey-5 mbtom-0">{item.role}</p>
										</div>
									</div>
								</div>
							</div>
						</li>
					))}
				</ul>
			</section>
		) : (
			<p className="detail-info">No recipients</p>
		)}
		<div className="form-button-group mtop-24">
			<Button className="btn-primary w-100" onClick={closeModal}>
				Close
			</Button>
		</div>
	</>
);

export default RecipientsModal;
